export default __webpack_public_path__ + "static/gallery_bg-46f16b4569f485314827ab95097cc527.png";